import React from "react";
import { Helmet } from "react-helmet";
import Sd_About_Dwadasa_Jyotirlingas from "../../Components/body/sd-about/sd-about-dwadasa-jyotirlingas";
import SdBreadcrumb from "../../Components/sd-common-components/sd-breadcrumb";
const Sd_Dwadasa_Jyotirlingas = () => {
  return (
    <div className="w-100">
      <Helmet>
        <meta charSet="utf-8" />
        <title> About Us | Online Pooja Booking | Devasthanam </title>
        <meta
          name="description"
          content="Dwadasa Jyotirlingas Page of Online Pooja Booking  | Devasthanam"
        />
        <meta
          name="keywords"
          content="Online Pooja Booking  | Devasthanam , Dwadasa Jyotirlingas"
        />
      </Helmet>
      <SdBreadcrumb from="Dwadasa Jyotirlingas" />

      <Sd_About_Dwadasa_Jyotirlingas />
    </div>
  );
};
export default Sd_Dwadasa_Jyotirlingas;
